// extracted by mini-css-extract-plugin
module.exports = {"bvpPlayerContainer":"_7dc5097","bvpPlayerIframe":"_abb51ed"};